import {
  call as rsCall,
  put as rsPut,
  all as rsAll,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';

import { isArray } from './array';

const createSuccessAction = (type, payload) => ({
  type,
  payload,
});

const createErrorAction = (type, error, payload) => ({
  type,
  payload: {
    error,
    ...payload,
  },
});

export const makeSagaHandler = ({ type, call, onSuccess, onFailure }) => (
  function* (action = {}) {
    try {
      const { payload } = action || {};
      const response = yield rsCall(call, payload);

      const puts = [
        rsPut(createSuccessAction(type.SUCCESS, response)),
      ];

      if (onSuccess) {
        if (isArray(onSuccess)) {
          onSuccess.forEach(fn => puts.push(rsPut(fn(response))));
        } else {
          puts.push(rsPut(onSuccess(response)));
        }
      }

      yield rsAll(puts);
    } catch (e) {
      const { payload } = action || {};
      console.error(type.FAILURE, e, payload);

      const puts = [
        rsPut(createErrorAction(type.FAILURE, e, payload)),
      ];

      if (onFailure) {
        if (isArray(onFailure)) {
          onFailure.forEach(fn => puts.push(rsPut(fn(e, payload))));
        } else {
          puts.push(rsPut(onFailure(e, payload)));
        }
      }

      yield rsAll(puts);
    }
  }
);

// USAGE: rename the following method to makeSagaHandler and comment out
// the helper above to set the entire app in an evergreen state

export const makeSagaHandlerDebug = ({ type, call, action }) => (
  function* () {
    let response = { data: [] };
    const { payload } = action || {};

    if (type.REQUEST.indexOf('INDEX') === -1) {
      response = yield rsCall(call, payload);
    }

    yield rsPut(createSuccessAction(type.SUCCESS, response));
  }
);

export const makeTakeEvery = saga => takeEvery(saga.type.REQUEST, makeSagaHandler(saga));
export const makeTakeLatest = saga => takeLatest(saga.type.REQUEST, makeSagaHandler(saga));



// WEBPACK FOOTER //
// ./src/helpers/sagas.js